import AudioPlayer from 'react-player';
import { useEffect, useState, useContext, useRef } from 'react';
import { AudioAutoPlayerContext } from './AudioAutoPlayerContext';

// We need this component because once mounted it will be playing a mute sound constantly so the we can play the real sounds at will. If we would insert it with the context provider it will be playing forever that mute sound.

// Insert it in the componnt tree symply like this <AudioAutoPlayer />
// and then use the AudioAutoPlayerContext to activate it:
// const audioAutoPlayerContext = useContext(AudioAutoPlayerContext);
//
export default function AudioAutoPlayer() {
  const playerRef = useRef(null);
  const { state, actions } = useContext(AudioAutoPlayerContext);
  useEffect(() => {
    actions.onPlayerMounted(playerRef);
    return () => {
      actions.onPlayerUnmount();
    };
  }, [playerRef]);

  return (
    <audio
      src={state.currentAudio}
      ref={playerRef}
      onEnded={actions.onAudioEnded}
      loop
      autoPlay={false}
    ></audio>
  );
}
